import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActionDialogComponent } from '../components/dialogs/action-dialog/action-dialog.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';
import { InfoDialogComponent } from '../services/dialog/components/info-dialog/info-dialog.component';
import { MaterialModule } from './material.module';
import { TranslateModule } from './translate.module';
import { CookieConsentComponent } from "../components/cookie-consent/cookie-consent.component";
import { NotificationsComponent } from '../components/notifications/notifications.component';


const components = [SnackbarComponent, ActionDialogComponent, LoaderComponent, SidebarComponent, InfoDialogComponent, CookieConsentComponent, NotificationsComponent];

@NgModule({
  imports: [FormsModule, CommonModule, MaterialModule, TranslateModule
  ],
  declarations: [...components],
  exports: [MaterialModule, TranslateModule, ...components],
})
export class SharedModule { }
